import { PayloadAction } from "@reduxjs/toolkit";
import { CustomerState } from "../customer.slice.ts";
import { AddressRequest } from "../../../../orchestrator-api-client";

export const submitAddressReducer = (
  state: CustomerState,
  action: PayloadAction<AddressRequest>,
) => {
  state.addressInfo.residence = action.payload.residence!; // TODO: Must be set as non-nullable on swagger
  state.addressInfo.domicile = action.payload.domicile!; // TODO: Must be set as non-nullable on swagger
};
